import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'

const FavoriteButton = ({ isFavorite, handleClick, className }) =>
  <Wrapper
    className={ className }
    aria-label={ isFavorite ? 'remove from favorites' : 'add to favorites' }
    onClick={ handleClick }>
    <HeartIcon alt="" asset={ isFavorite ? 'heart-red-filled' : 'heart-red' } />
  </Wrapper>

FavoriteButton.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  isFavorite: PropTypes.bool
}

const Wrapper = styled.button`
  height: 35px;
  width: 35px;
  padding: 2px;
  background: ${Theme.colors.white_smoke_medium};
  border: 0;
  border-radius: 50%;
  cursor: pointer;
`

const HeartIcon = styled(Icon)`
  width: 19px;
  height: 18px;
`

export default FavoriteButton
